import moment from "moment";
import { CSSProperties, useEffect, useRef } from "react";
import { useLocalSampleSummaryParams } from "../../hooks";
import ReportSummaryContainer from "./ReportSummaryContainer";

import useIsPageLoaded from "./hooks/useIsPageLoaded";
import "./report-summary-pdf.module.scss";

type Props = {
  onFinishedDownloading?: () => void;
};

const STYLE: CSSProperties = {
  position: "absolute",
  left: "-1000000px",
  top: 0,
  width: "1440px",
  overflow: "hidden"
};

const ReportSummaryContainerPDFExport = ({ onFinishedDownloading }: Props) => {
  const { hash } = useLocalSampleSummaryParams();

  const isLoaded = useIsPageLoaded();

  const container = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const root = container.current;

    if (!root || !isLoaded) return;

    // Lazy so jspdf and html2canvas stay out of the eagerly loaded bundles
    import(
      "../../../../tcbase/pdf/exportDomToPdf" /* webpackChunkName: 'pdfExport' */
    )
      .then(({ exportDomToPdf }) =>
        exportDomToPdf(root, {
          filename: `${hash}_${moment().format("YYYY-MM-DD")}`,
          margin: 30
        })
      )
      .catch(error => console.error("Short PDF export failed", error))
      .finally(() => onFinishedDownloading?.());
  }, [isLoaded, onFinishedDownloading, hash]);

  return (
    // pdf-export scopes the pdf-* layout helpers in report-summary-pdf.module.scss
    <div style={STYLE} className="pdf-export" ref={container}>
      <div style={{ width: "1400px" }}>
        <ReportSummaryContainer isPdfView />
      </div>
    </div>
  );
};

export default ReportSummaryContainerPDFExport;
